import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/SecondaryVanDashboardForm';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const SecondaryVanDashboardForm = ({ t }) => (
  <Container>
       
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

SecondaryVanDashboardForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(SecondaryVanDashboardForm);
